import {USER_IDLE} from "../../actions/IdleActions";

const initialState = {
    idle: false,
};

const IdleReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_IDLE:
            return {...state, idle: true};
        default:
            return state;
    }
};

export default IdleReducer;



// WEBPACK FOOTER //
// ./src/reducers/idle/IdleReducer.js